import { c as _c } from "react/compiler-runtime";
import Hero from "@/components/home/Hero";
import Stats from "@/components/home/Stats";
import CommunityNews from "@/components/home/CommunityNews";
import Mission from "@/components/home/Mission";
import Timeline from "@/components/home/Timeline";
import Countries from "@/components/home/Countries";
import WorldMap from "@/components/home/WorldMap";
import UpcomingEvents from "@/components/home/UpcomingEvents";
import Archives from "@/components/home/Archives";
import ResearchCTA from "@/components/home/ResearchCTA";
import FAQ from "@/components/shared/FAQ";
import LazyOnView from "@/components/shared/LazyOnView";
import SeoHead from "@/components/seo/SeoHead";
import { organizationJsonLd, seoFromPage, websiteJsonLd } from "@/lib/seo";
export default function Home() {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = seoFromPage("home");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const seo = t0;
  let t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SeoHead {...seo} jsonLd={[organizationJsonLd(), websiteJsonLd()]} />;
    t2 = <Hero />;
    t3 = <Stats />;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <LazyOnView minHeight={520}><CommunityNews /></LazyOnView>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <LazyOnView minHeight={480}><Mission /></LazyOnView>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <LazyOnView minHeight={720}><Timeline /></LazyOnView>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <LazyOnView minHeight={640}><Countries /></LazyOnView>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <LazyOnView minHeight={420}><WorldMap /></LazyOnView>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <LazyOnView minHeight={480}><UpcomingEvents /></LazyOnView>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <LazyOnView minHeight={360}><FAQ /></LazyOnView>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <LazyOnView minHeight={560}><Archives /></LazyOnView>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <>{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}<LazyOnView minHeight={380}><ResearchCTA /></LazyOnView></>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  return t12;
}